import { useState } from "react";
import { useAuth } from "../AuthContext";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await login(email.trim(), password);
    setSubmitting(false);
  };

  return (
    <div className="dsl-login-shell" data-testid="login-shell">
      <form className="dsl-login-card" onSubmit={onSubmit} data-testid="login-form">
        <h1>Project New Agency</h1>
        <p className="sub">Sign in with your account.</p>

        <label htmlFor="login-email">Email</label>
        <input
          id="login-email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="login-email-input"
        />

        <label htmlFor="login-password">Password</label>
        <input
          id="login-password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid="login-password-input"
        />

        {error ? <div className="err" data-testid="login-error">{error}</div> : null}

        <button
          type="submit"
          className="btn"
          disabled={submitting}
          data-testid="login-submit-button"
        >
          {submitting ? "Signing in…" : "Sign in"}
        </button>

        <div className="dsl-login-hint">
          Two accounts exist for this project.<br />
          Marco signs in as admin; Ward signs in as reviewer.
        </div>
      </form>
    </div>
  );
}
